module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "quill-editor"
  }, [_vm._t("toolbar"), _vm._v(" "), _c('div', {
    ref: "editor"
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-33c83a00"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-quill-editor/src/editor.vue
// module id = 497
// module chunks = 0